<template>
  <div id="tempcreate-layer">
    <light-header :back="backUrl"></light-header>
    <div class="tempcreate-content page-layer">
      <!-- <el-tabs type="border-card" v-model="tenantId">
                <el-tab-pane :label="item.spaceName" v-for="item in spaceList" :key="item.tenantId" :name="item.tenantId"></el-tab-pane>
            </el-tabs> -->
      <div class="tempcreate-files">
        <!-- <h3 class="tempcreate-title">添加文件和签约方</h3> -->
        <div class="area-title">
          <span class="bar"></span>
          <span>添加文件和签约方</span>
        </div>
        <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="100px" label-position="left"
          style="margin-top: 20px;">
          <el-form-item prop="taskName" label="主题名称" :rules="[
            { required: true, message: '请输入主题名称', trigger: 'blur' },
            { validator: checkContractName, trigger: 'blur' },
          ]">
            <el-input size="small" maxlength="50" v-model="filesForm.taskName" style="width: 70%"
              @blur="() => { filesForm.taskName = filesForm.taskName.trim() }"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="ctype" label="类型" :rules="[
                            { required: currentSpace.companyId, message: '请选择类型', trigger: 'change' }
                        ]" v-if="currentSpace.companyId">
                        <el-select :disabled="isUser" v-model="filesForm.ctype" clearable placeholder="合同类型" style="width: 220px">
                            <el-option v-for="item in contractTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item> -->
          <el-form-item prop="signExpireTime" label="签署截止日" :rules="[
            { required: true, message: '请选择签署截止日', trigger: 'blur' },
          ]">
            <el-date-picker size="small" style="width: 220px" placeholder="请选择日期" v-model="filesForm.signExpireTime"
              type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item prop="lawStartTime" label="合同生效时间">
            <el-date-picker style="width: 220px" placeholder="请选择合同生效时间" v-model="filesForm.lawStartTime" type="date"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd"
              @change="handleChangeLawEndTime('lawStartTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="lawEndTime" label="合同终止时间">
            <el-date-picker style="width: 220px" placeholder="请选择合同终止时间" v-model="filesForm.lawEndTime" type="date"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="handleChangeLawEndTime('lawEndTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="filesForm.remark" type="textarea" placeholder="请填写备注内容" maxlength="100" show-word-limit
              style="width: 70%"></el-input>
          </el-form-item> -->
          <el-form-item prop="addFileWay" label="添加方式" :rules="[
            { required: true, message: '请选择添加文件方式', trigger: 'blur' },
            { validator: checkContractName, trigger: 'blur' },
          ]">
            <el-radio-group v-model="filesForm.addFileWay" @change="handleChangeAddFileWay"
              style="height: 32px;display: flex;align-items: center;">
              <el-radio label="upload">上传文件</el-radio>
              <el-radio label="template" v-if="spaceType == 'company'">选择模板</el-radio>
            </el-radio-group>
          </el-form-item>


          <div class="tempcreate-upload" v-if="filesForm.addFileWay == 'upload'">
            <el-upload ref="upload" accept=".pdf" :action="templateUploadUrl" :headers="myHeaders"
              list-type="picture-card" :on-change="handleUploaded" :on-success="handleFileSuccess"
              :on-progress="handleUploading" :on-error="handleFileError" :before-upload="handleTemplateBeforeUpload">
              <i slot="default" class="el-icon-plus"></i>
              <div class="upload-tip">上传合同</div>
              <div slot="file" slot-scope="{ file }" v-loading="file.status == 'uploading'"
                element-loading-text="文件上传中……">
                <img class="el-upload-list__item-thumbnail" :src="defaultPDF" alt="" />
                <div class="file-name">{{ file.name }}</div>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handleFilePreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
              <img v-for="(img, index) in pngList" :key="index" width="100%" :src="img" alt="" />
            </el-dialog>
          </div>
          <div class="tempcreate-upload" v-else>
            <div class="el-upload el-upload--picture-card" @click="templateToQuery" v-if="!templateData.selectedTemplate">
              <i class="el-icon-document"></i>
              <div class="upload-tip">选择模板</div>
            </div>
            <div v-else class="el-upload-list el-upload-list--picture-card">
              <div class="el-upload-list__item">
                <img class="el-upload-list__item-thumbnail" :src="defaultPDF" alt="" />
                <div class="file-name">{{
                  templateData.selectedTemplate.templateName + "." +
                  templateData.selectedTemplate.templateType
                }}</div>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handleTemplateFilePreview()">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleTemplateRemove()">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>

            </div>
            <el-dialog title="选择合同模板" :visible.sync="templateData.templateShow" width="790px" append-to-body
              :close-on-click-modal="false">
              <div style="padding-bottom: 25px">
                <el-table :data="templateData.templateList" style="width: 100%; width: 100%">
                  <el-empty description="暂无数据" slot="empty"></el-empty>
                  <el-table-column label="选择" prop="check" width="80">
                    <template slot-scope="scope">
                      <el-checkbox v-model="scope.row.check" @change="handleTemplateSelectionChange(scope.row.id)">
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="templateName" label="合同模板名称" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="fileName" label="合同模板附件" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="createBy" label="添加人" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="personAddress" label="添加时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="scope-content">
                        <span>{{ scope.row.createTime }}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pager-layer">
                  <el-pagination v-if="
                    templateData.templateList &&
                    templateData.templateList.length &&
                    templateData.total > 5
                  " :total="templateData.total" :current-page.sync="templateData.queryParams.pageNum"
                    style="margin-top: 8px; position: absolute; right: 8px" layout="total, prev, pager, next"
                    :page-size.sync="templateData.queryParams.pageSize" @size-change="templateSizeChange"
                    @current-change="templatePageChange" />
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="useTemplateConfirm" size="small">确定</el-button>
                <el-button @click="cancelUseTemplate" size="small">取消</el-button>
              </div>
            </el-dialog>
          </div>

          <div class="batch-create-block">
            <el-button type="primary" @click="handleTemplateBatchCreate" size="small"
              v-if="filesForm.addFileWay == 'template'" :disabled="!templateData.selectedTemplate">批量发起</el-button>
          </div>



          <!-- <el-form-item prop="noneSequence" label="无序签署">
     
          </el-form-item> -->
        </el-form>

        <!-- <div>
                    <label>主题名称</label>

                    <el-input v-model="taskName" size="small" style="width: 200px;margin-top: 27px;"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <label>签署截止日</label>

                    <el-date-picker v-model="signExpireTime" size="small" type="date" placeholder="请选择日期">
                    </el-date-picker>
                </div> -->

        <!-- <ul class="el-upload-list el-upload-list--picture-card" v-if="isEdit">
                        <li tabindex="0" class="el-upload-list__item is-success">
                            <div data-v-0aca0cd4="">
                                <img data-v-0aca0cd4="" :src="defaultPDF" alt="" class="el-upload-list__item-thumbnail">
                                <span data-v-0aca0cd4="" class="el-upload-list__item-actions">
                                    <span data-v-0aca0cd4="" class="el-upload-list__item-preview" @click="handleFilePreview()">
                                        <i data-v-0aca0cd4="" class="el-icon-zoom-in"></i>
                                    </span>

                                    <span v-if="!isUser" data-v-0aca0cd4="" class="el-upload-list__item-delete" @click="handleRemove()">
                                        <i data-v-0aca0cd4="" class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </li>
                    </ul> -->

        <!-- <div class="uploaded-list">
                        <div class="uploaded-item" v-for="file in signFileInfoArray" :key="file.fileId">
                            <img class="file-thumb" :src="defaultPDF" alt="">
                            <div class="file-name">{{file.fileName}}</div>
                            <span class="file-actions">
                                <span class="file-preview">
                                    <i class="el-icon-zoom-in" @click="handleFilePreview(file.fileImgArray, true)"></i>
                                </span>
                                <span class="file-delete">
                                    <i class="el-icon-delete" @click="handleRemove(file)"></i>
                                </span>
                            </span>

                        </div>
                    </div> -->

        <!-- <p class="upload-tip2" v-if="!isUser">仅支持Word文档模板，文档大小 < 20M</p>
                        <div class="upload-progress clearfix" v-show="percentage>0 && percentage< 100">
                            <div class="progress-box">
                                <el-progress :percentage="percentage"></el-progress>
                            </div>
                        </div>
                        <div class="files-form-box">
                            <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="100px" class="files-Form">
                                <el-form-item prop="cname" :label="isUser?'合同名称':'模板名称'" :rules="[
                { required: true, message: '请输入模板名称', trigger: 'blur' },
                { validator: checkContractName, trigger: 'blur' }
              ]">
                                    <el-input maxlength="50" v-model="filesForm.cname"></el-input>
                                </el-form-item>
                                <el-form-item prop="ctype" label="类型" :rules="[
                { required: currentSpace.companyId, message: '请选择类型', trigger: 'change' }
              ]" v-if="currentSpace.companyId">
                                    <el-select :disabled="isUser" v-model="filesForm.ctype" clearable placeholder="合同类型" style="width: 220px">
                                        <el-option v-for="item in contractTypes" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="isUser" prop="cdate" label="签署截止日" :rules="[
                { required: isUser, message: '请选择签署截止日', trigger: 'blur' }
              ]">
                                    <el-date-picker style="width: 220px;" v-model="filesForm.cdate" type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd hh:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-form>
                        </div> -->
      </div>
    </div>

    <div class="tempcreate-params-box page-layer"
      v-if="templateParamsForm.params && templateParamsForm.params.length && !batchFileChecked">
      <el-form :model="templateParamsForm" ref="templateParamsForm" label-width="100px" label-position="left"
        class="template-params-Form">
        <el-form-item v-for="(param, index) in templateParamsForm.params" :label="param.name" :key="index"
          :prop="'params.' + index + '.value'" :rules="{
            required: true, message: '请输入变量' + param.name, trigger: 'change'
          }">
          <el-input size="small" type="textarea" autosize show-word-limit maxlength="50" v-model="param.value"
            style="width: 70%" :placeholder="param.name" @blur="() => { param.value = param.value.trim() }"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="tempcreate-users-box page-layer">
      <div class="add-user-btns" v-if="filesForm.addFileWay == 'upload'">
        <div class="add-btns">
          <el-button size="small" @click="addSignatory('company')" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加企业
          </el-button>
          <el-button size="small" @click="addSignatory('person')" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加个人
          </el-button>
          <el-button size="small" @click="addSignatoryUserSelf()" type="primary" plain><i
              class="el-icon-plus el-icon--right"></i>
            添加己方为签署方
          </el-button>
        </div>
        <!-- <el-button :disabled="isBatch === 1 || isBatch === 0" @click="batchHandle(1)" class="add-btn">批量导入企业<i class="el-icon-plus el-icon--right"></i></el-button>
                <el-button :disabled="isBatch === 1 || isBatch === 0" @click="batchHandle(0)" class="add-btn">批量导入个人<i class="el-icon-plus el-icon--right"></i></el-button> -->
      </div>
      <!-- <div class="add-user-btns clearfix" v-else>
        <el-button style="float: left" icon="el-icon-plus" @click="downloadTemplateHandle()" class="add-btn">下载模板
        </el-button>
        <div style="float: left; height: 36px; overflow: hidden">
          <el-upload class="upload-demo" ref="tempupload" :file-list="tempList" :on-success="uploadTemplateSuccess"
            :action="templateUrl" :headers="myHeaders">
            <el-button size="medium" type="primary">上传模板</el-button>
          </el-upload>
        </div>
      </div> -->

      <div class="signatory-list">
        <div class="none-sequence">
          无序签署&nbsp;&nbsp;<el-switch v-model="noneSequence" active-value="yes" inactive-value="no"></el-switch>
        </div>
        <div v-if="!batchFileChecked">
          <el-card class="signatory-item" v-for="sign in signatoryList" :key="sign.signSequence" shadow="hover">
            <h3 class="signatory-item-title">
              签约方-{{ sign.signSubject == "person" ? "个人" : "企业" }}
            </h3>
            <div class="signatory-body" v-if="sign.signSubject == 'person'">
              <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
              <div class="sub-title">个人信息</div>
              <div class="signatory-form clearfix">
                <div class="signatory-form-item">
                  <div class="signatory-form-item-inp">
                    <el-input size="small" maxlength="14" placeholder="手机号" v-model="sign.personAddress"
                      @blur="handleGetSignerInfo(sign, 'person')">
                      <el-button size="small" slot="append" icon="el-icon-notebook-1" style="font-size: 16px"
                        @click="handleUseUserContact(sign.signSequence, 'person')"></el-button>
                    </el-input>
                    <!-- <div class="tip" v-show="sign.tip">{{sign.tip}}</div> -->
                  </div>
                </div>
                <div class="signatory-form-item">
                  <div class="signatory-form-item-inp">
                    <el-input size="small" maxlength="30" placeholder="姓名" v-model="sign.personName"
                      @blur="handleGetSignerInfo(sign, 'person')" />
                  </div>
                </div>

                <!-- <div class="signatory-form-item" v-if="sign.signingBody == 1">
                                <div class="signatory-form-item-title">经办人账号</div>
                                <div class="signatory-form-item-inp">
                                    <el-input disabled maxlength="14" v-model="sign.agentAccount" />
                                </div>
                            </div>
                            <div class="signatory-form-item" v-if="sign.signingBody == 1">
                                <div class="signatory-form-item-title">经办人姓名</div>
                                <div class="signatory-form-item-inp">
                                    <el-input disabled maxlength="30" v-model="sign.agentName" />
                                </div>
                            </div> -->
              </div>

              <!-- <div class="auth-tag" v-if="sign.tip">
              <span>{{ sign.tip }}</span>
            </div> -->

              <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                <span>{{ sign.tip }}</span>
              </div>
              <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                  <div>
                    <div>添加未认证个人或企业步骤：</div>
                    <div>
                      1.
                      请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                    </div>
                    <div>2. 注册成功后完成个人或企业实名认证；</div>
                    <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                  </div>
                  <div slot="reference" class="auth-tip">
                    <div class="auth-tip-text">{{ sign.tip }}</div>
                    <i class="el-icon-question"></i>
                  </div>
                </el-popover>
              </div>
            </div>
            <div v-else>
              <div class="signatory-body">
                <span style="width: 10px; color: #f56c6c; margin-right: 4px">*</span>
                <div class="sub-title">企业名称</div>
                <el-input size="small" maxlength="50" v-model="sign.companyName" style="width: 500px; margin-right: 34px"
                  @blur="handleGetSignerInfo(sign, 'company')">
                  <el-button size="small" slot="append" icon="el-icon-notebook-1" style="font-size: 16px"
                    @click="handleUseUserContact(sign.signSequence, 'company')"></el-button>
                </el-input>
                <!-- <div class="auth-tag" v-if="sign.tipCompany">
                <span>{{ sign.tipCompany }}</span>
              </div> -->
                <div class="auth-tag" v-if="sign.tipCompany && sign.tipCompany == '已实名'">
                  <span>{{ sign.tipCompany }}</span>
                </div>
                <div class="auth-tag icon-question" v-if="sign.tipCompany && sign.tipCompany == '未实名'">
                  <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                    <div>
                      <div>添加未认证个人或企业步骤：</div>
                      <div>
                        1.
                        请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                      </div>
                      <div>2. 注册成功后完成个人或企业实名认证；</div>
                      <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                    </div>
                    <div slot="reference" class="auth-tip">
                      <div class="auth-tip-text">{{ sign.tipCompany }}</div>
                      <i class="el-icon-question"></i>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="signatory-body">
                <span style="width: 10px; color: #f56c6c; margin-right: 4px" v-if="sign.requireAgentField">*</span>
                <span style="width: 10px; color: #f56c6c; margin-right: 4px" v-else></span>
                <div class="sub-title">经办人</div>
                <div class="signatory-form clearfix">
                  <div class="signatory-form-item">
                    <div class="signatory-form-item-inp">
                      <!-- <img class="mail-icon" @click="showContactHandle(sign)" src="../../assets/images/sign/mail-icon.png" alt=""> -->
                      <el-input size="small" maxlength="14" placeholder="手机号" v-model="sign.companyAgentAddress"
                        @blur="handleGetSignerInfo(sign, 'agent')" />
                      <!-- <div class="tip" v-show="sign.tip">{{sign.tip}}</div> -->
                    </div>
                  </div>
                  <div class="signatory-form-item">
                    <div class="signatory-form-item-inp">
                      <el-input size="small" maxlength="30" placeholder="姓名" v-model="sign.companyAgentName"
                        @blur="handleGetSignerInfo(sign, 'agent')" />
                    </div>
                  </div>
                  <!-- <div class="signatory-form-item" v-if="sign.signingBody == 1">
                                <div class="signatory-form-item-title">经办人账号</div>
                                <div class="signatory-form-item-inp">
                                    <el-input disabled maxlength="14" v-model="sign.agentAccount" />
                                </div>
                            </div>
                            <div class="signatory-form-item" v-if="sign.signingBody == 1">
                                <div class="signatory-form-item-title">经办人姓名</div>
                                <div class="signatory-form-item-inp">
                                    <el-input disabled maxlength="30" v-model="sign.agentName" />
                                </div>
                            </div> -->
                </div>

                <div class="auth-tag" v-if="sign.tip && sign.tip == '已实名'">
                  <span>{{ sign.tip }}</span>
                </div>
                <div class="auth-tag icon-question" v-if="sign.tip && sign.tip == '未实名'">
                  <el-popover placement="top-start" title="提示" width="300" trigger="hover">
                    <div>
                      <div>添加未认证个人或企业步骤：</div>
                      <div>
                        1.
                        请通知该个人或企业访问平台地址（https://jitsign.com/home/login）选择账号完成注册；
                      </div>
                      <div>2. 注册成功后完成个人或企业实名认证；</div>
                      <div>3. 完成认证后即可添加该个人或企业为签署方</div>
                    </div>
                    <div slot="reference" class="auth-tip">
                      <div class="auth-tip-text">{{ sign.tip }}</div>
                      <i class="el-icon-question"></i>
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>

            <!-- <img
            v-if="!isUser"
            src="../../assets/images/sign/delete.png"
            @click="deleteSignatory(sign.signSequence)"
            class="signatory-delete"
            alt=""
          /> -->
            <el-button type="text" class="signatory-delete" icon="el-icon-delete" circle
              v-if="filesForm.addFileWay == 'upload'" @click="deleteSignatory(sign.signSequence)"></el-button>
            <!-- <i class="el-icon-delete signatory-delete" v-if="!isUser" @click="deleteSignatory(sign.signSequence)"></i> -->
          </el-card>

          <el-card class="signatory-batch signatory-item" v-show="isBatch === 1 || isBatch === 0">
            <h3 class="signatory-item-title">
              签约方-{{ isBatch == 0 ? "个人" : "企业" }}
            </h3>
            <div class="signatory-batch-content">
              <div>
                <span class="circle">1</span>
                <span>下载<el-button type="text">《批量导入企业模板》</el-button></span>
              </div>
              <div>
                <span class="circle">2</span>
                <span>点此处上传<el-upload class="upload-btn" action="https://jsonplaceholder.typicode.com/posts/">
                    <el-button size="small" type="primary">上 传</el-button>
                  </el-upload></span>
              </div>
              <div>
                <span class="circle">3</span>
                <span>检查核对签约方信息</span>
              </div>
              <!-- <div class="signatory-batch-text">
                            上传批量{{isBatch === 0 ? '个人' : '企业'}}签约方
                        </div> -->
            </div>
            <!-- <img v-if="!isUser" @click="deleteBatchSignatory" src="../../assets/images/sign/delete.png" class="signatory-delete" alt=""> -->
          </el-card>

          <el-card class="signatory-batch-success" :class="{ h180: isBatchOk }" v-show="isBatchOk" shadow="hover">
            <h3 class="signatory-item-title">
              签约方-批量{{ batchType === 0 ? "个人" : "企业" }}
            </h3>
            <div class="signatory-batch-content2">
              <div class="signatory-batch-text">
                {{ batchMsg }}
              </div>
              <div class="signatory-batch-text">
                <div style="float: left">
                  <a href="javascript:;" @click="showBatchSignatory" class="show-signatory">点此查看</a>
                  <span>签约方信息</span>
                </div>
              </div>
            </div>
            <img v-if="!isUser" @click="deleteBatchSignatory" src="../../assets/images/sign/delete.png"
              class="signatory-delete" alt="" />
          </el-card>
        </div>
        <div v-else>
          <div class="none-sequence">
            导入成功条目：{{ batchFileCheckData.successNum }} <span style="margin-left: 40px;">导入失败条目：{{
              batchFileCheckData.failedNum
            }}</span>
            <el-button type="text" icon="el-icon-delete" @click="handleRemoveAllFailItem"
              style="margin-left: 40px;">移除全部失败条目</el-button>
          </div>
          <div>
            <el-table :data="batchFileCheckData.rowArray" style="width: 100%" class="batch-file-data-table">
              <el-table-column prop="line" label="行号" width="100">
              </el-table-column>
              <el-table-column prop="signUserArray" label="签署方" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ formatSignUserArray(scope.row.signUserArray) }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="paramArray" label="变量赋值" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ formatParamArray(scope.row.paramArray) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg" label="校验结果" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.msg == 'yes'">校验成功</el-tag>
                  <el-tag type="danger" style="display: block;" v-else>
                    <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                      {{ scope.row.msg }}
                    </div>
                  </el-tag>
                </template>

              </el-table-column>
              <el-table-column label="操作" width="120px">
                <template slot-scope="scope">
                  <el-button type="text"
                    @click="handlePreviewTemplateWithCertainParam(scope.row.paramArray)">预览</el-button>
                  <el-button type="text" style="margin-left:10px;" class="danger"
                    @click="handleRemoveLineItem(scope.$index)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="sign-btns" v-if="!isUser">
        <div v-if="!batchFileChecked">
          <el-button size="small" type="primary" @click="templateHandle('toSign')"
            v-if="this.filesForm.addFileWay == 'upload'">
            指定签署位置
          </el-button>
          <el-button size="small" type="primary" @click="saveToSend" v-else>保存到待发送</el-button>
          <el-button size="small" plain @click="templateHandle('save')">保存草稿</el-button>
          <el-button size="small" plain @click="handlePreviewTemplateWithParam"
            :disabled="!templateData.selectedTemplate">预览
          </el-button>
        </div>
        <div v-else>
          <el-button size="small" type="primary" @click="batchSaveToSend">批量保存到待发送</el-button>
          <el-button size="small" plain @click="batchTemplateHandle">批量保存草稿</el-button>
        </div>

      </div>
      <div class="sign-btns" v-else>
        <el-button size="small" type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '2' : '5')">{{
          progessText1
        }}</el-button>
        <el-button size="small" type="primary" :disabled="clickSubmit" @click="templateSign(isProgess ? '1' : '4')">{{
          progessText2
        }}</el-button>
      </div>
    </div>
    <template-list ref="temp" @saveBatch="saveBatchHandle"></template-list>
    <el-drawer title="" :visible.sync="descOpen" direction="rtl" custom-class="desc-drawer" append-to-body
      :show-close="true" :modal="false" :withHeader="true" size="80%">
      <div>
        <desc-drawer :from="'myLaunch'" :descData="descData" @changeDescOpen="changeDescOpen"></desc-drawer>
      </div>
    </el-drawer>
    <el-dialog :title="userContact.title" :visible.sync="userContact.userContactShow" width="790px" append-to-body
      :close-on-click-modal="false" custom-class="contact-dialog">
      <div style="padding-bottom: 25px">
        <div class="filter-layer">
          <el-form ref="queryForm" :inline="true" label-width="70px" label-position="left">
            <el-form-item label="查询条件" prop="condition">
              <el-input v-model="userContact.queryParams.condition" @clear="toQuery" placeholder="请输入名称/手机号/备注" clearable
                size="small" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="toQuery" style="margin-left: 24px">查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="userContact.contactList" style="width: 100%">
          <el-empty description="暂无数据" slot="empty"></el-empty>
          <el-table-column label="选择" prop="check" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.check" @change="handleSelectionChange(scope.row.id)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="企业名称" v-if="userContact.queryParams.subject == 'company'"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.subject == 'company'">
                <span>{{ scope.row.companyName }}</span>
              </div>
              <div class="scope-content" v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="subject" label="联系人类型">
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{
                scope.row.subject == "person" ? "个人" : "企业"
                }}</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="personName" label="联系人姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.personName">
                <span>{{ scope.row.personName }}</span>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="personAddress" label="联系方式" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.personAddress">
                <span>{{ scope.row.personAddress }}</span>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              <div v-if="scope.row.remark">
                <span>{{ scope.row.remark }}</span>
              </div>
              <div v-else>
                无
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager-layer">
          <el-pagination v-if="
            userContact.contactList &&
            userContact.contactList.length &&
            userContact.total > 5
          " :total="userContact.total" :current-page.sync="userContact.queryParams.pageNum"
            style="margin-top: 8px; position: absolute; right: 8px" layout="total, prev, pager, next"
            :page-size.sync="userContact.queryParams.pageSize" @size-change="sizeChange" @current-change="pageChange" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="useContactConfirm" size="small">确定</el-button>
        <el-button @click="cancelUseContact" size="small">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入发起签署任务列表" :visible.sync="importBatchFileOpen" width="700px" append-to-body
      :close-on-click-modal="false">
      <div class="import-head">
        <span>示例下载：</span>
        <el-link type="primary" @click="handleDownLoadImportBatchFileTemplate">批量签署模板.xlsx</el-link>
      </div>
      <el-form ref="importBatchFileForm" :model="importBatchFileForm" label-width="0" label-position="left">
        <el-form-item style="text-align: center">
          <el-upload ref="importBatchFile" class="upload-demo" drag :action="importBatchFileAction"
            :headers="importBatchFileheaders" :data="uploadImportBatchFileData" :on-remove="removeImportBatchFileDoc"
            :on-success="uploadImportBatchFileSuccess" :before-upload="beforeImportBatchFileUpload" :limit="1"
            :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelImportBatchFile">取消上传</el-button>
        <el-button size="small" type="primary" @click="confirmImportBatchFile">确定上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui"
import { mapState } from "vuex"
import axios from "axios"
import { getToken, getConsoleUrl } from "@/utils/auth"
import {
  getSignerInfo,
  saveDraft,
  getSignFileImgArrayApi,
  contractTemplateImgApi,
  templateEditApi,
  getTemplatetSignListApi,
  getTemplateInfoApi,
  downloadTemplateApi,
  createContractByTemplateApi,
  getTemplateList,
  replaceAfterPreview,
  queryTemplateParams,
  saveToBeSent,
  getCurrentUserSignInfo,
  getTaskImportTemplate,
  excelTaskParsing,
  importBatchFileAction,
  batchSaveDraft,
  batchSaveToBeSent
} from "@/api/template/index";
import { getDraftInfo } from "@/api/sign/sign";
import { getContactList } from "@/api/contact";
import { getContractTypeApi, getContractInfoApi } from "@/api/sign/flow";
import { getIsNotProgessApi } from "@/api/sign/set-control";
import { parseTime, downloadFile } from "@/utils/index";
import templateList from "../sign/template-list";
import lightHeader from "@/components/lightHeader";
import descDrawer from "./descDrawer";
import moment from "moment";
export default {
  components: {
    templateList,
    descDrawer,
    lightHeader,
  },
  computed: {
    ...mapState(["companyList", "currentSpace", "userInfo", "spaceInfoList"]),
    isUser() {
      return this.$route.query.isuse == 1 ? true : false;
    },
    uploadData() {
      if (this.currentSpace) {
        return { companyId: this.currentSpace.companyId };
      } else {
        return { companyId: "" };
      }
    },
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      signId: "",
      tenantId: this.$store.state.currentSpace.tenantId,
      spaceList: this.$store.state.spaceInfoList,
      spaceType: this.$store.state.spaceInfoList.find(item => {
        return item.tenantId == this.$store.state.currentSpace.tenantId
      }).spaceType,
      filesForm: {
        addFileWay: "upload",
        taskName: "",
        signExpireTime: "",
        lawStartTime: "",
        lawEndTime: "",
        remark: ""
      },
      signFileInfoArray: [],

      // taskName: "",
      // signExpireTime: "",
      fileIdArray: [],

      clickSubmit: false,
      templateUploadUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadSignFile",
      templateUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "contractTemplate/saveTemplate",
      myHeaders: {
        Authorization: getToken(),
      },
      // uploadData: {
      //   companyId: this.currentSpace.companyId || ''
      // },
      dialogVisible: false,
      pngList: [],
      percentage: 0,

      filesRules: {},
      contractTypes: [],
      defaultPDF: require("../../assets/images/sign/pdf.png"),
      disabled: false,
      isBatch: "",
      signatoryList: [],
      batchSignatoryList: [],
      isEdit: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      progessText1: "送审",
      progessText2: "保存待送审",
      tempList: [],
      isBatchOk: false,
      batchMsg: "",
      isProgess: false,
      keyWordMap: {},
      batchType: 0,
      uploadingLoading: false,

      descOpen: false,
      descData: {},

      userContact: {
        title: "",
        userContactShow: false,
        total: "",
        multipleSelection: undefined,
        refSequence: "",
        queryParams: {
          pageNum: 1,
          pageSize: 5,
          subject: "",
          condition: ""
        },
        contactList: [],
      },

      templateData: {
        selectedTemplate: null,
        templateShow: false,
        total: "",
        multipleSelection: undefined,
        refSequence: "",
        queryParams: {
          pageNum: 1,
          pageSize: 5
        },
        templateList: [],
      },
      templateParamsForm: {
        params: []
      },
      noneSequence: "no",
      spaceUserInfo: null,

      importBatchFileOpen: false,
      importBatchFileheaders: {
        Authorization: getToken(),
      },
      uploadImportBatchFileData: {},
      importBatchFileForm: {},
      importBatchFileAction: importBatchFileAction,
      batchFileChecked: false,
      batchFileCheckData: {}
    };
  },
  watch: {
    descOpen(newV, oldV) {
      if (newV) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
  created() {
    this.taskId = this.$route.query.taskId;
    this.initGetCurrentUserSignInfo();

    if (this.taskId) {
      getDraftInfo({
        taskId: this.taskId,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.noneSequence = res.data.noneSequence;
          if (res.data.hasOwnProperty("templateId")) {
            this.filesForm.addFileWay = "template";
            this.handleQueryTemplateParamsRevealDraft(res.data.templateId, res.data.templateParam);
          } else {
            this.$refs.upload.uploadFiles.push(...res.data.signFileInfoArray);
          }
          this.filesForm.taskName = res.data.taskName;
          this.filesForm.signExpireTime = res.data.signExpireTime;
          this.filesForm.lawStartTime = res.data.lawStartTime;
          this.filesForm.lawEndTime = res.data.lawEndTime;
          this.filesForm.remark = res.data.remark;
          // this.signFileInfoArray = res.data.signFileInfoArray;

          res.data.signFileInfoArray.map((item) => {
            item.uid = item.fileId;
            item.name = item.fileName;
            this.fileIdArray.push(item.fileId);
          });
          this.signatoryList.push(...res.data.signUserArray);
          this.signatoryList.map((item) => {
            this.$set(item, "tip", "");
            this.$set(item, "tipCompany", "");
            this.handleGetSignerInfo(item, item.signSubject);
            if (
              item.signSubject === "company" &&
              item.companyAgentName &&
              item.companyAgentAddress
            ) {
              this.handleGetSignerInfo(item, "agent");
            }
          });
        }
      });
    }
    // if (this.$route.query.templateId) {
    // 	this.getTemplatetSignListHandle();
    // 	this.getTemplateInfoHandle();
    // 	// this.fileId = this.$route.query.templateId;
    // }
    // if (this.$route.query.isuse == 1) {
    // 	this.getIsNotProgessHandle();
    // }
    // this.getContractTypeHandle();
  },
  methods: {
    handleRemoveAllFailItem() {
      this.$confirm(`确定要移除全部失败条目吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let allPassCheckData = this.batchFileCheckData.rowArray.filter(item => {
            return item.msg == "yes";
          })
          this.batchFileCheckData.rowArray = allPassCheckData;
          this.batchFileCheckData.successNum = allPassCheckData.length;
          this.batchFileCheckData.failedNum = 0;
        })
        .catch(() => { });
    },
    handleRemoveLineItem($index) {
      this.$confirm(`确定要移除此条目吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.batchFileCheckData.rowArray[$index].msg == "yes") {
            this.batchFileCheckData.successNum--;
          } else {
            this.batchFileCheckData.failedNum--;
          }
          this.batchFileCheckData.rowArray.splice($index, 1);
        })
        .catch(() => { });
    },
    formatSignUserArray(signUserArray) {
      let ret = [];
      ret = signUserArray.map(item => {
        return item.signSubject == "person" ?
          (item.personAddress + "/" + item.personName) :
          (item.companyAgentAddress ?
            (item.companyName + "/" + item.companyAgentAddress + "/" + item.companyAgentName) :
            item.companyName)
      })
      return ret.join("、")
    },
    formatParamArray(paramArray) {
      let ret = [];
      Object.keys(paramArray).forEach((key) => {
        ret.push("" + key + "(" + paramArray[key] + ")")
      })
      return ret.join("、")
    },
    transformLabelFromkey(key) {
      switch (key) {
        case "companyName":
          return "企业名称";
          break;
        case "companyAgentName":
          return "经办人姓名";
          break;
        case "companyAgentAddress":
          return "经办人手机号";
          break;
        case "personName":
          return "经办人姓名";
        case "personAddress":
          return "经办人手机号";
          break;
        default:
          return ""
      }
    },
    handleChangeLawEndTime(field) {
      if (this.filesForm.lawStartTime && this.filesForm.lawEndTime) {
        const diff = moment(this.filesForm.lawEndTime).diff(moment(this.filesForm.lawStartTime), 'days');
        if (diff < 0) {
          this.$message({
            showClose: true,
            message: "合同生效时间不能大于合同终止时间！",
            type: "warning",
          });
          this.filesForm[field] = "";
        }
      }

    },
    batchSaveToSend() {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          if (!this.templateData.selectedTemplate) {
            this.$message({
              showClose: true,
              message: "请选择签署模板！",
              type: "warning",
            });
            return;
          }

          if (this.batchFileCheckData.failedNum > 0) {
            this.$message({
              showClose: true,
              message: "存在校验未通过数据，请手动处理导入失败条目或重新上传！",
              type: "warning",
            });
            return;
          }

          if (this.batchFileCheckData.rowArray.length <= 0) {
            this.$message({
              showClose: true,
              message: "没有导入的条目，请重新上传！",
              type: "warning",
            });
            return;
          }




          // if (!this.signatoryList.length) {
          //   this.$message({
          //     showClose: true,
          //     message: "请指定签署方信息！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // this.$refs.templateParamsForm.validate((valid) => {
          //   if (!valid) {
          //     return;
          //   } else {
          //   }
          // })




          // if (this.signatoryList.some(item => {
          //   return !item.personName && !item.companyName
          // })) {
          //   this.$message({
          //     showClose: true,
          //     message: "请指定签署方信息！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // if (this.signatoryList.some(item => {
          //   return item.requireAgentField && !item.companyAgentName
          // })) {
          //   this.$message({
          //     showClose: true,
          //     message: "经办人姓名账号不能为空！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // toSend handler



          this.$confirm(`此次批量生成${this.batchFileCheckData.successNum}份合同`, "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          })
            .then(() => {
              let loadingInstance = Loading.service({
                fullscreen: true,
              });
              // let paramObject = {};
              // this.templateParamsForm.params.map(item => {
              //   paramObject[item.name] = item.value;
              // })
              let taskArray = this.batchFileCheckData.rowArray.map(item => {
                return {
                  signUserArray: item.signUserArray,
                  templateParam: item.paramArray
                }
              })
              batchSaveToBeSent({
                templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
                taskId: this.taskId ? this.taskId : undefined,
                taskName: this.filesForm.taskName,
                taskType: "normal",
                taskArray: taskArray,
                signExpireTime: this.filesForm.signExpireTime,
                signFileIdArray: this.fileIdArray,
                noneSequence: this.noneSequence,
                lawStartTime: this.filesForm.lawStartTime,
                lawEndTime: this.filesForm.lawEndTime,
                remark: this.filesForm.remark,
              }).then(res => {
                loadingInstance.close();
                if (res.code !== 200) {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "warning",
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.push({
                    name: "ContractList",
                    query: {
                      status: "waitSend"
                    },
                  });
                }
              }).catch(err => {
                loadingInstance.close();
              })
            })
            .catch(() => { });





        }
      })
    },
    batchTemplateHandle() {
      if (this.uploadingLoading) {
        this.$message({
          showClose: true,
          message: "请等待文件上传完毕！",
          type: "warning",
        });
        return;
      }
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          if (!this.templateData.selectedTemplate) {
            this.$message({
              showClose: true,
              message: "请选择签署模板！",
              type: "warning",
            });
            return;
          }
          if (this.batchFileCheckData.failedNum > 0) {
            this.$message({
              showClose: true,
              message: "存在校验未通过数据，请手动处理导入失败条目或重新上传！",
              type: "warning",
            });
            return;
          }

          if (this.batchFileCheckData.rowArray.length <= 0) {
            this.$message({
              showClose: true,
              message: "没有导入的条目，请重新上传！",
              type: "warning",
            });
            return;
          }

          // if (!this.signatoryList.length) {
          //   this.$message({
          //     showClose: true,
          //     message: "请指定签署方信息！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // this.$refs.templateParamsForm.validate((valid) => {
          //   if (!valid) {
          //     return;
          //   } else {

          //   }
          // })

          // if (this.signatoryList.some(item => {
          //   return !item.personName && !item.companyName
          // })) {
          //   this.$message({
          //     showClose: true,
          //     message: "请指定签署方信息！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // if (this.signatoryList.some(item => {
          //   return item.requireAgentField && !item.companyAgentName
          // })) {
          //   this.$message({
          //     showClose: true,
          //     message: "经办人姓名账号不能为空！",
          //     type: "warning",
          //   });
          //   return;
          // }

          this.$confirm(`此次批量生成${this.batchFileCheckData.successNum}份合同草稿`, "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          })
            .then(() => {
              this.batchSaveDraftHandler();
            })
            .catch(() => { });


        }
      });
    },
    batchSaveDraftHandler() {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      // 提交保存项
      // let paramObject;
      // if (this.filesForm.addFileWay == 'template') {
      //   paramObject = {};
      //   this.templateParamsForm.params.map(item => {
      //     paramObject[item.name] = item.value;
      //   })
      // }
      let taskArray = this.batchFileCheckData.rowArray.map(item => {
        return {
          signUserArray: item.signUserArray,
          templateParam: item.paramArray
        }
      })
      batchSaveDraft({
        templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
        taskId: this.taskId ? this.taskId : undefined,
        taskName: this.filesForm.taskName,
        taskType: "normal",
        taskArray: taskArray,
        signExpireTime: this.filesForm.signExpireTime,
        // initiatorTenantId: this.tenantId,
        // signUserArray: this.signatoryList,
        signFileIdArray: this.fileIdArray,
        noneSequence: this.noneSequence,
        lawStartTime: this.filesForm.lawStartTime,
        lawEndTime: this.filesForm.lawEndTime,
        remark: this.filesForm.remark,
      }).then((res) => {
        loadingInstance.close();
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
          });
          // if (this.$route.query.from) {
          //   this.$router.push({
          //     path: this.$route.query.from.replace(/\!\!/g, "?"),
          //   });
          // } else {
          //   this.$router.go(-1);
          // }
          this.$router.push({
            name: "ContractList",
            query: {
              status: "draft"
            },
          });
        }
      }).catch(err => {
        loadingInstance.close();
      });
    },
    handleDownLoadImportBatchFileTemplate() {
      getTaskImportTemplate({
        templateId: this.templateData.selectedTemplate.id
      }).then(res => {
        downloadFile(res, "批量签署模板", "xlsx");
      })
    },
    removeImportBatchFileDoc() { },

    uploadImportBatchFileSuccess() { },

    beforeImportBatchFileUpload(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.msgError("只允许上传10M以内的文件");
        return false
      }
      if (file.name.substr(file.name.lastIndexOf(".")) != ".xls" && file.name.substr(file.name.lastIndexOf(".")) != ".xlsx") {
        this.msgError("文件格式错误，仅支持xls、xlsx格式的文件");
        return false
      }
      return true
    },

    cancelImportBatchFile() {
      this.batchFileChecked = false;
      this.batchFileCheckData = {};
      this.$refs.importBatchFile.clearFiles();
      this.importBatchFileOpen = false;
    },

    confirmImportBatchFile() {
      if (this.$refs.importBatchFile.uploadFiles && this.$refs.importBatchFile.uploadFiles[0]) {
        this.batchFileChecked = false;
        this.batchFileCheckData = {};
        // 手动上传
        let forms = new FormData()
        forms.append('templateId', this.templateData.selectedTemplate.id)
        forms.append('file', this.$refs.importBatchFile.uploadFiles[0].raw)
        axios({
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + getToken() },
          data: forms,
          url: this.importBatchFileAction
        }).then(res => {
          if (res.data.code == 200) {
            this.$refs.importBatchFile.clearFiles();
            this.importBatchFileOpen = false;
            this.msgSuccess(res.data.message);
            this.batchFileChecked = true;
            this.batchFileCheckData = res.data.data;
            // this.getContactList();
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "warning",
            });
          }
        }).catch(() => {
          this.$refs.importBatchFile.clearFiles();
        })
      } else {
        this.$message({
          showClose: true,
          message: "请先上传签署列表文件",
          type: "warning",
        });
      }

    },
    handleTemplateBatchCreate() {
      this.importBatchFileOpen = true;

    },
    initGetCurrentUserSignInfo() {
      getCurrentUserSignInfo().then(res => {
        if (res.code == 200) {
          this.spaceUserInfo = res.data;
        }
      })
    },
    useContactConfirm() {
      if (!this.userContact.multipleSelection) {
        this.$message({
          showClose: true,
          message: "请先选择联系人",
          type: "warning",
        });
        return;
      }
      this.userContact.userContactShow = false;
      const ref = this.signatoryList.find((_item) => {
        return (_item.signSequence == this.userContact.refSequence);
      });
      if (ref.signSubject == "company") {
        ref.companyName = this.userContact.multipleSelection.companyName;
        ref.companyAgentName = this.userContact.multipleSelection.personName;
        ref.companyAgentAddress =
          this.userContact.multipleSelection.personAddress;
        this.handleGetSignerInfo(ref, ref.signSubject);
        if (ref.companyAgentAddress) {
          this.handleGetSignerInfo(ref, "agent");
        }
      } else {
        ref.personName = this.userContact.multipleSelection.personName;
        ref.personAddress = this.userContact.multipleSelection.personAddress;
        this.handleGetSignerInfo(ref, ref.signSubject)
      }

    },
    cancelUseContact() {
      this.userContact.userContactShow = false;
    },
    handleSelectionChange(val) {
      this.userContact.contactList.map((_item) => {
        if (_item.id === val) {
          _item.check = true;
          this.userContact.multipleSelection = _item;
        } else {
          _item.check = false;
        }
      });
    },
    sizeChange() {
      this.toQuery();
    },
    pageChange() {
      this.toQuery();
    },
    toQuery() {
      this.getContactList();
    },
    handleUploaded() {
      this.uploadingLoading = false;
    },
    handleUploading() {
      this.uploadingLoading = true;
    },
    handleUseUserContact(signSequence, type) {
      this.userContact.refSequence = signSequence;
      this.userContact.queryParams.subject = type;
      if (type == "company") {
        this.userContact.title = "选择企业联系人";
      } else {
        this.userContact.title = "选择个人联系人";
      }
      this.getContactList();
    },
    getContactList() {
      getContactList(this.userContact.queryParams)
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.data.rowArray.map((item) => {
              item.check = false;
            });
            this.userContact.contactList = res.data.rowArray;
            this.userContact.total = res.data.total;
            this.userContact.userContactShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    useTemplateConfirm() {
      if (!this.templateData.multipleSelection) {
        this.$message({
          showClose: true,
          message: "请先选择模板",
          type: "warning",
        });
        return;
      } else {
        this.templateData.templateShow = false;
        this.templateData.selectedTemplate = this.templateData.multipleSelection;
        this.handleQueryTemplateParams();
        // 获取模板fileId
        this.handleTemplateFilePreview(undefined, true);
      }


    },
    handleQueryTemplateParamsRevealDraft(templateId, templateParam) {
      queryTemplateParams({
        templateId: templateId
      }).then(res => {
        if (res.code == 200) {
          let paramObject = JSON.parse(templateParam);
          this.templateParamsForm.params = Object.keys(paramObject).map(key => {
            return {
              name: key,
              value: paramObject[key]
            }
          });
          this.templateData.selectedTemplate = {
            id: templateId,
            templateName: res.data.templateName,
            templateType: ".docx"
          };
        } else {
          this.msgWarn(res.message);
        }

      })
    },
    handleQueryTemplateParams() {
      queryTemplateParams({
        templateId: this.templateData.selectedTemplate.id
      }).then(res => {
        this.templateParamsForm.params = res.data.paramArray.map(item => {
          return {
            name: item,
            value: ""
          }
        })
        res.data.subjectArray.map(item => {
          let hasAgentFlag = false;
          if (item.signSubject == "company") {
            hasAgentFlag = item.positionArray.some(_item => {
              return _item.sealType == "companyAgent"
            })
          }
          this.insertSignatory(item.signSequence, item.signSubject, hasAgentFlag);
        })
      })
    },
    cancelUseTemplate() {
      this.templateData.templateShow = false;
    },
    handleChangeAddFileWay() {
      this.templateData.selectedTemplate = null;
      this.signatoryList = [];
      this.fileIdArray = [];
      this.templateParamsForm.params = [];
      this.batchFileChecked = false;
    },
    handleTemplateRemove() {
      this.templateData.selectedTemplate = null;
      this.signatoryList = [];
      this.fileIdArray = [];
      this.templateParamsForm.params = [];

      this.batchFileChecked = false;
      this.batchFileCheckData = {};
    },
    handleTemplateFilePreview(param, isSaveFileId) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0, 0, 0, 0)',
        lock: true
      });
      replaceAfterPreview({
        templateId: this.templateData.selectedTemplate.id,
        paramObject: param
      }).then(ret => {
        if (ret.code != 200) {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: ret.message,
            type: "warning",
          });
        } else {
          if (isSaveFileId) {
            loadingInstance.close();
            this.templateData.selectedTemplate.fileId = ret.data.fileId;
            this.fileIdArray = [ret.data.fileId];
          } else {
            getSignFileImgArrayApi({
              signFileId: ret.data.fileId,
            }).then((res) => {
              loadingInstance.close();
              this.$nextTick(() => {
                this.descData = {
                  signFileInfoArray: [
                    {
                      fileName: this.templateData.selectedTemplate.templateName,
                      fileImgArray: res.data.signFileImgArray,
                    },
                  ],
                };
                this.descOpen = true;
              });
            }).catch(err => {
              loadingInstance.close();
            });
          }

        }

      })

    },
    handleTemplateSelectionChange(val) {
      this.templateData.templateList.map((_item) => {
        if (_item.id === val) {
          _item.check = true;
          this.templateData.multipleSelection = _item;
        } else {
          _item.check = false;
        }
      });
    },
    templateSizeChange() {
      this.templateToQuery();
    },
    templatePageChange() {
      this.templateToQuery();
    },
    templateToQuery() {
      this.getTemplateList();
    },
    getTemplateList() {
      getTemplateList(this.templateData.queryParams)
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.data.rows.map((item) => {
              item.check = false;
              item.createTime = moment(item.createTime).format("YYYY-MM-DD hh:mm:ss");
            });
            this.templateData.templateList = res.data.rows;
            this.templateData.total = res.data.total;
            this.templateData.templateShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleGetSignerInfo(signObj, signBody) {
      if (
        signBody === "person" &&
        (!signObj.personAddress || !signObj.personName)
      ) {
        signObj.tip = "";
        return;
      }
      if (
        signBody === "agent" &&
        (!signObj.companyAgentAddress || !signObj.companyAgentName)
      ) {
        signObj.tip = "";
        return;
      }
      if (signBody === "company" && !signObj.companyName) {
        signObj.tipCompany = "";
        return;
      }

      let params = {};
      if (signBody === "person") {
        params.signSubject = "person";
        params.personAddress = signObj.personAddress;
        params.personName = signObj.personName;
      } else if (signBody === "agent") {
        params.signSubject = "person";
        params.personAddress = signObj.companyAgentAddress;
        params.personName = signObj.companyAgentName;
      } else {
        params.signSubject = "company";
        params.companyName = signObj.companyName;
      }

      getSignerInfo(params).then((res) => {
        if (signBody == "company") {
          signObj.tipCompany =
            res.data.status == "passAuth" ? "已实名" : "未实名";
        } else {
          signObj.tip = res.data.status == "passAuth" ? "已实名" : "未实名";
        }
      });
    },

    returnIndex() {
      // this.$router.push('/')
      window.location.href = getConsoleUrl() + "/templateCenter/template";
    },
    handleFileSuccess(response, file, fileList) {
      if (response.code != 200) {
        this.$message({
          showClose: true,
          message: response.message,
          type: "warning",
        });
        // this.$refs.upload.clearFiles();
        // this.isEdit = false
        // this.fileId = "";
        // this.fileIdArray = [];
      } else {
        // this.defaultPDF =
        this.fileIdArray.push(response.data.signFileId);
        // this.filesForm.cname = file.name.substring(
        // 	0,
        // 	file.name.lastIndexOf(".")
        // );
        this.isUpload = true;

        // var uploadTimer = null;
        // var progressTimer = null;

        // uploadTimer = setInterval(() => {
        // 	this.percentage += 2;
        // 	if (this.percentage >= 99) {
        // 		this.percentage = 99;
        // 		clearInterval(uploadTimer);

        // 		progressTimer = setInterval(() => {
        // 			contractTemplateImgApi(
        // 				this.fileId || this.$route.query.templateId
        // 			)
        // 				.then(res => {
        // 					if (res.code == "0") {
        // 						this.percentage = 100;
        // 						clearInterval(progressTimer);
        // 					}
        // 				})
        // 				.catch(err => {
        // 					console.log(err);
        // 				});
        // 		}, 1000);
        // 	}
        // }, 60);
      }
    },
    handleFileError(err, file, fileList) {
      console.log(err);
      this.$message({
        showClose: true,
        message: "文件上传失败！",
        type: "warning",
      });
    },
    handleTemplateBeforeUpload(file) {
      if (this.$refs.upload.uploadFiles.length >= 6) {
        this.$message.warning(`最多可上传5份文件！`);
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (type != "pdf") {
        // this.$refs.upload.clearFiles();
        this.$message.warning(`请上传pdf文件！`);
        return false;
      } else {
        if (file.size > 100 * 1024 * 1024) {
          this.$message.warning(`文件大小超出100M限制，请重新上传！`);
          return false;
        } else {
        }
      }

      if (file.size > 100 * 1024 * 1024) {
        this.$message.warning(`文件大小超出100M限制，请重新上传！`);
        return false;
      } else {
      }
    },
    // handleFilePreview(file) {
    //   if (file.fileImgArray) {
    //     this.pngList = file.fileImgArray;
    //     this.dialogVisible = true;
    //   } else {
    //     // 查看上传文件
    //     getSignFileImgArrayApi({
    //       signFileId: file.response.data.signFileId,
    //     }).then((res) => {
    //       // this.pngList = res.data.signFileImgArray.map(el => {
    //       // 	return ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + el;
    //       // });
    //       this.pngList = res.data.signFileImgArray;
    //       this.dialogVisible = true;
    //     });
    //   }
    // },
    handleRemove(file) {
      // 缩略图模板里删除文件
      let fileList = this.$refs.upload.uploadFiles;
      let index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      fileList.splice(index, 1);
      this.fileIdArray.splice(index, 1);
      // this.$refs.upload.clearFiles();
      // this.isEdit = false;
      // this.fileId = "";
      // this.percentage = 0;
    },
    checkContractName(rule, value, callback) {
      var reg = new RegExp(
        '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
      );
      if (!reg.test(value)) {
        callback(new Error('合同名不能包含下列任何字符:/:*?"<>|'));
      } else {
        callback();
      }
    },
    getContractImgsHandle() {
      return new Promise((resolve, reject) => {
        contractTemplateImgApi(this.fileId || this.$route.query.templateId)
          .then((res) => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              resolve(res.data.pngList);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    getContractTypeHandle() {
      getContractTypeApi(this.currentSpace.companyId).then((res) => {
        if (res.code != "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.contractTypes = res.data;
        }
      });
    },
    addSignatoryUserSelf() {
      let spaceInfo = this.spaceList.find(item => {
        return item.tenantId == this.tenantId;
      })

      var signSequence = 0;
      if (this.batchSignatoryList.length > 0) {
        signSequence = this.signatoryList.length + 2;
      } else {
        signSequence = this.signatoryList.length + 1;
      }

      let signObj = {
        signSequence: signSequence,
        companyName: spaceInfo.spaceType == "company" ? spaceInfo.spaceName : "",
        signSubject: spaceInfo.spaceType,
        // userName: "",
        personAddress: spaceInfo.spaceType == "person" ? this.spaceUserInfo.address : "",
        personName: spaceInfo.spaceType == "person" ? spaceInfo.spaceName : "",
        companyAgentAddress: (spaceInfo.spaceType == "company" && this.spaceUserInfo.userType == "person") ? this.spaceUserInfo.address : "",
        companyAgentName: (spaceInfo.spaceType == "company" && this.spaceUserInfo.userType == "person") ? this.spaceUserInfo.name : "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipCompany: "",
      }
      this.handleGetSignerInfo(signObj, spaceInfo.spaceType);
      if (signObj.companyAgentAddress) {
        this.handleGetSignerInfo(signObj, "agent");
      }
      this.signatoryList.push(signObj);
    },
    addSignatory(signSubject) {
      var signSequence = 0;
      if (this.batchSignatoryList.length > 0) {
        signSequence = this.signatoryList.length + 2;
      } else {
        signSequence = this.signatoryList.length + 1;
      }
      this.signatoryList.push({
        signSequence: signSequence,
        companyName: "",

        signSubject: signSubject,
        // userName: "",
        personAddress: "",
        personName: "",
        companyAgentAddress: "",
        companyAgentName: "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipCompany: "",
      });
    },
    insertSignatory(signSequence, signSubject, hasAgentFlag) {
      this.$set(this.signatoryList, signSequence - 1, {
        signSequence: signSequence,
        companyName: "",
        signSubject: signSubject,
        // userName: "",
        personAddress: "",
        personName: "",
        companyAgentAddress: "",
        companyAgentName: "",
        // agentList: [],
        // companyId: "",
        tip: "",
        tipCompany: "",
        requireAgentField: hasAgentFlag
      })
      // this.signatoryList[signSequence - 1] = {
      //   signSequence: signSequence,
      //   companyName: "",
      //   signSubject: signSubject,
      //   // userName: "",
      //   personAddress: "",
      //   personName: "",
      //   companyAgentAddress: "",
      //   companyAgentName: "",
      //   // agentList: [],
      //   // companyId: "",
      //   tip: "",
      //   tipCompany: "",
      // };
    },
    deleteSignatory(index) {
      this.signatoryList.forEach((item, i) => {
        if (item.signSequence === index) {
          this.signatoryList.splice(i, 1);
        }
      });

      this.signatoryList.forEach((d, j) => {
        d.signSequence = j + 1;
      });
    },
    batchHandle(type) {
      this.isBatch = type;
      this.batchType = type;
      this.batchSignatoryList.push({
        signSequence: this.signatoryList.length + 1,
        signSubject: type,
        personAddress: "",
        personName: "",
        agentAccount: "",
        agentName: "",
      });
    },
    deleteBatchSignatory() {
      this.isBatch = "";
      this.batchSignatoryList = [];
      this.signatoryList.forEach((item, index) => {
        item.signSequence = parseInt(index) + 1;
      });
    },
    saveToSend() {
      let returnFlag = false;
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          if (!this.templateData.selectedTemplate) {
            this.$message({
              showClose: true,
              message: "请选择签署模板！",
              type: "warning",
            });
            return;
          }
          if (!this.signatoryList.length) {
            this.$message({
              showClose: true,
              message: "请指定签署方信息！",
              type: "warning",
            });
            return;
          }

          if (this.templateParamsForm.params.length) {
            this.$refs.templateParamsForm.validate((valid) => {
              if (!valid) {
                returnFlag = true;
                return;
              }
            })
          }
          if (returnFlag) {
            return;
          }
          if (this.signatoryList.some(item => {
            return !item.personName && !item.companyName
          })) {
            this.$message({
              showClose: true,
              message: "请指定签署方信息！",
              type: "warning",
            });
            return;
          }


          if (this.signatoryList.some(item => {
            return item.requireAgentField && !item.companyAgentName
          })) {
            this.$message({
              showClose: true,
              message: "经办人姓名账号不能为空！",
              type: "warning",
            });
            return;
          }


          // toSend handler
          let loadingInstance = Loading.service({
            fullscreen: true,
          });
          let paramObject = {};
          this.templateParamsForm.params.map(item => {
            paramObject[item.name] = item.value;
          })
          saveToBeSent({
            taskId: this.taskId ? this.taskId : undefined,
            taskName: this.filesForm.taskName,
            taskType: "normal",
            signExpireTime: this.filesForm.signExpireTime,
            signUserArray: this.signatoryList,
            signFileIdArray: this.fileIdArray,
            templateParam: paramObject,
            templateId: this.templateData.selectedTemplate.id,
            noneSequence: this.noneSequence,
            lawStartTime: this.filesForm.lawStartTime,
            lawEndTime: this.filesForm.lawEndTime,
            remark: this.filesForm.remark,
          }).then(res => {
            loadingInstance.close();
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.$router.push({
                name: "ContractList",
                query: {
                  status: "waitSend"
                },
              });
            }
          }).catch(err => {
            loadingInstance.close();
          })

        }
      })
    },
    templateHandle(type) {
      if (this.uploadingLoading) {
        this.$message({
          showClose: true,
          message: "请等待文件上传完毕！",
          type: "warning",
        });
        return;
      }
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          var reg = /^[\u0391-\uFFE5]+$/;
          if (this.filesForm.addFileWay == 'upload') {
            if (!this.fileIdArray.length) {
              this.$message({
                showClose: true,
                message: "请上传合同！",
                type: "warning",
              });
              return;
            }
            if (!this.signatoryList.length) {
              this.$message({
                showClose: true,
                message: "请添加签署人！",
                type: "warning",
              });
              return;
            }
            if (this.signatoryList.some(item => {
              return !item.personName && !item.companyName
            })) {
              this.$message({
                showClose: true,
                message: "请指定签署方信息！",
                type: "warning",
              });
              return;
            }

            if (this.signatoryList.some(item => {
              return item.requireAgentField && !item.companyAgentName
            })) {
              this.$message({
                showClose: true,
                message: "经办人姓名账号不能为空！",
                type: "warning",
              });
              return;
            }

            this.saveDraftHandler(type);
          } else {
            if (!this.templateData.selectedTemplate) {
              this.$message({
                showClose: true,
                message: "请选择签署模板！",
                type: "warning",
              });
              return;
            }
            if (!this.signatoryList.length) {
              this.$message({
                showClose: true,
                message: "请指定签署方信息！",
                type: "warning",
              });
              return;
            }
            this.$refs.templateParamsForm.validate((valid) => {
              if (!valid) {
                return;
              } else {
                if (this.signatoryList.some(item => {
                  return !item.personName && !item.companyName
                })) {
                  this.$message({
                    showClose: true,
                    message: "请指定签署方信息！",
                    type: "warning",
                  });
                  return;
                }
                if (this.signatoryList.some(item => {
                  return item.requireAgentField && !item.companyAgentName
                })) {
                  this.$message({
                    showClose: true,
                    message: "经办人姓名账号不能为空！",
                    type: "warning",
                  });
                  return;
                }

                this.saveDraftHandler(type);
              }
            })
          }
        }
      });
    },
    saveDraftHandler(type) {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      // 提交保存项
      let paramObject;
      if (this.filesForm.addFileWay == 'template') {
        paramObject = {};
        this.templateParamsForm.params.map(item => {
          paramObject[item.name] = item.value;
        })
      }
      saveDraft({
        taskId: this.taskId ? this.taskId : undefined,
        taskName: this.filesForm.taskName,
        taskType: "normal",
        signExpireTime: this.filesForm.signExpireTime,
        // initiatorTenantId: this.tenantId,
        signUserArray: this.signatoryList,
        signFileIdArray: this.fileIdArray,
        templateId: this.filesForm.addFileWay == 'template' ? this.templateData.selectedTemplate.id : undefined,
        templateParam: paramObject,
        noneSequence: this.noneSequence,
        lawStartTime: this.filesForm.lawStartTime,
        lawEndTime: this.filesForm.lawEndTime,
        remark: this.filesForm.remark,
      }).then((res) => {
        loadingInstance.close();
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          if (type == "save") {
            this.$message({
              showClose: true,
              message: "保存成功",
              type: "success",
            });
            // if (this.$route.query.from) {
            //   this.$router.push({
            //     path: this.$route.query.from.replace(/\!\!/g, "?"),
            //   });
            // } else {
            //   this.$router.go(-1);
            // }
            this.$router.push({
              name: "ContractList",
              query: {
                status: "draft"
              },
            });
          } else {
            let taskId = res.data.taskId;
            this.$router.push({
              path: "/sign",
              query: {
                taskId,
                from: this.$route.query.from,
              },
            });
          }
        }
      }).catch(err => {
        loadingInstance.close();
      });
    },
    handlePreviewTemplateWithCertainParam(paramArray) {
      this.handleTemplateFilePreview(paramArray);
    },
    handlePreviewTemplateWithParam() {
      let paramObject = {};
      this.templateParamsForm.params.map(item => {
        paramObject[item.name] = item.value;
      })
      this.handleTemplateFilePreview(paramObject);
    },
    toPositionHandle(signatoryList) {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      this.isDraftOk = true;
      templateEditApi({
        contractName: this.filesForm.cname,
        companyId: this.currentSpace.companyId || "",
        contractFileId: this.fileId,
        contractTypeId: this.filesForm.ctype,
        templateId: this.$route.query.templateId || this.fileId,
        signatoryList,
        batchSignatoryList: this.batchSignatoryList,
      })
        .then((res) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            this.isDraftOk = false;
            return;
          } else {
            this.$router.push({
              path: "/set-temp-control",
              query: {
                templateId: res.data.contractId,
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTemplatetSignListHandle() {
      getTemplatetSignListApi({
        templateId: this.$route.query.templateId,
        nocache: new Date().getTime(),
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.signatoryList = res.data.signatoryList;
            this.batchSignatoryList = res.data.batchSignatoryList;
            if (this.batchSignatoryList.length > 0) {
              this.isBatch = this.batchSignatoryList[0].signSubject;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTemplateInfoHandle() {
      getTemplateInfoApi(this.$route.query.templateId)
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.filesForm.cname = res.data.contractName;
            this.filesForm.ctype = res.data.contractTypeId;
            if (this.filesForm.cname) {
              this.isEdit = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadTemplateHandle() {
      downloadTemplateApi(this.$route.query.templateId).then((res) => {
        downloadFile(res, "模板文件", "xlsx");
      });
    },
    uploadTemplateSuccess(response, file, fileList) {
      if (response.code !== "0") {
        this.$message({
          showClose: true,
          message: response.message,
          type: "warning",
        });
      } else {
        this.$refs.temp.templateData = response.result.batchSignatoryList;
        this.signatoryList = response.result.signatoryList;
        this.batchSignatoryList = response.result.batchSignatoryList;
        this.keyWordMap = response.result.keyWordMap;
        if (this.batchSignatoryList.length > 0) {
          this.isBatchOk = true;
          this.$refs.temp.templateType = this.batchSignatoryList[0].signSubject;
        } else {
          this.isBatchOk = false;
        }

        this.isBatch = "";
        this.batchMsg = response.result.msg;
      }
    },
    showBatchSignatory() {
      this.$refs.temp.dialogVisible = true;
    },
    saveBatchHandle(batchData) {
      this.batchSignatoryList = batchData;
    },
    getIsNotProgessHandle() {
      getIsNotProgessApi({
        contractId: this.$route.query.templateId,
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            if (res.data.success == "false") {
              this.progessText1 = "发送";
              this.progessText2 = "保存待发送";
              this.isProgess = false;
            } else {
              this.progessText1 = "送审";
              this.progessText2 = "保存待送审";
              this.isProgess = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    templateSign(status) {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          var reg = /^[\u0391-\uFFE5]+$/;
          if (!this.fileId && !this.$route.query.templateId && this.filesForm.addFileWay == 'upload') {
            this.$message({
              showClose: true,
              message: "请上传合同！",
              type: "warning",
            });

            return;
          }

          var dateTime = new Date(this.filesForm.cdate).getTime();
          var now = new Date();
          var year = now.getFullYear();
          var month = now.getMonth();
          var date = now.getDate();
          var time = year + "-" + (month + 1) + "-" + date;
          var todayTime = new Date(time).getTime();

          if (dateTime < todayTime) {
            this.$message({
              showClose: true,
              message: "请修改截止日期！",
              type: "warning",
            });

            return;
          }

          if (this.signatoryList.length > 0) {
            let isvalid = true;

            for (var i = 0; i < this.signatoryList.length; i++) {
              if (!this.signatoryList[i].personAddress) {
                this.$message({
                  showClose: true,
                  message: "账号不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryList[i].signSubject == "person" &&
                !this.signatoryList[i].personName
              ) {
                this.$message({
                  showClose: true,
                  message: "姓名不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryList[i].signSubject == "company" &&
                !this.signatoryList[i].personName
              ) {
                this.$message({
                  showClose: true,
                  message: "企业名称不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryList[i].signSubject == "company" &&
                !this.signatoryList[i].agentAccount
              ) {
                this.$message({
                  showClose: true,
                  message: "经办人账号不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }

              if (
                this.signatoryList[i].signSubject == "company" &&
                !this.signatoryList[i].agentName
              ) {
                this.$message({
                  showClose: true,
                  message: "经办人姓名不能为空！",
                  type: "warning",
                });

                isvalid = false;
                break;
              }
            }

            if (isvalid) {
              let signatoryList = [];
              this.signatoryList.forEach((item) => {
                signatoryList.push({
                  signSubject: item.signSubject,
                  signSequence: item.signSequence,
                  personAddress: item.personAddress,
                  personName: item.personName,
                  agentAccount: item.agentAccount,
                  agentName: item.agentName,
                });
              });

              for (var i = 0; i < signatoryList.length; i++) {
                for (var j = i + 1; j < signatoryList.length; j++) {
                  if (
                    signatoryList[i].signSubject ===
                    signatoryList[j].signSubject &&
                    signatoryList[i].personAddress ===
                    signatoryList[j].personAddress &&
                    signatoryList[i].personName ===
                    signatoryList[j].personName &&
                    signatoryList[i].agentAccount ===
                    signatoryList[j].agentAccount &&
                    signatoryList[i].agentName === signatoryList[j].agentName
                  ) {
                    this.$message({
                      showClose: true,
                      message: "存在重复签署方，请删除重复用户后再尝试提交！",
                      type: "warning",
                    });

                    find = true;

                    break;
                  }
                }

                if (find) break;
              }

              if (this.batchSignatoryList.length > 0) {
                for (var i = 0; i < signatoryList.length; i++) {
                  for (var j = 0; j < this.batchSignatoryList.length; j++) {
                    if (
                      signatoryList[i].signSubject ===
                      this.batchSignatoryList[j].signSubject &&
                      signatoryList[i].personAddress ===
                      this.batchSignatoryList[j].personAddress &&
                      signatoryList[i].personName ===
                      this.batchSignatoryList[j].personName &&
                      signatoryList[i].agentAccount ===
                      this.batchSignatoryList[j].agentAccount &&
                      signatoryList[i].agentName ===
                      this.batchSignatoryList[j].agentName
                    ) {
                      this.$message({
                        showClose: true,
                        message: "存在重复签署方，请删除重复用户后再尝试提交！",
                        type: "warning",
                      });

                      find = true;

                      break;
                    }
                  }

                  if (find) break;
                }
              }

              this.createContractByTemplateHandle(signatoryList, status);
            }
          } else {
            this.$message({
              showClose: true,
              message: "请添加单个签署方！",
              type: "warning",
            });
            console.log("error submit!");
            return false;
          }
        } else {
        }
      });
    },
    createContractByTemplateHandle(signatoryList, status) {
      createContractByTemplateApi({
        templateId: this.$route.query.templateId,
        status: status,
        endDate: moment(this.filesForm.cdate).format("YYYY-MM-DD"),
        contractName: this.filesForm.cname,
        batchSignatoryList: this.batchSignatoryList,
        keyWordMap: this.keyWordMap,
        signatoryList: signatoryList
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$message({
              message: "发起成功！",
              type: "success",
            });

            this.$router.push("/");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleFilePreview(file) {
      // 保存草稿已上传的文件预览
      if (file.fileImgArray && file.fileImgArray.length) {
        this.$nextTick(() => {
          this.descData = {
            signFileInfoArray: [
              {
                fileName: file.fileName,
                fileImgArray: file.fileImgArray,
              },
            ],
          };
          this.descOpen = true;
        });
      } else {
        // 查看上传文件
        getSignFileImgArrayApi({
          signFileId: file.response.data.signFileId,
        }).then((res) => {
          this.$nextTick(() => {
            this.descData = {
              signFileInfoArray: [
                {
                  fileName: file.name,
                  fileImgArray: res.data.signFileImgArray,
                },
              ],
            };
            this.descOpen = true;
          });
        });
      }
    },
    changeDescOpen(status) {
      this.descOpen = status;
    },
  },
};
</script>
<style>
/* #tempcreate-layer .el-table .cell {
  padding: 0 20px;
  font-size: 14px;
}

#tempcreate-layer .el-table tr {
  height: 72px;
}

#tempcreate-layer .el-table th>.cell {
  font-size: 16px;
} */

.tempcreate-upload .el-upload--picture-card {
  width: 142px;
  height: 142px;
  line-height: 138px;
}

.hide .el-upload--picture-card {
  display: none;
}

#tempcreate-layer .el-loading-spinner {
  height: 166px;
  margin-top: -43px;
}

.el-upload-list__item {
  transition: all 0.3s ease;
}

/* .contact-dialog .el-form-item__label {
  text-align: center;
} */
</style>
<style lang="scss" scoped>
.tempcreate-content {
  // font-size: 16px;
  // font-weight: 400;
  // color: #333333;
  // margin-top: 30px;

  /deep/ .el-tabs--border-card {
    border: none;
    box-shadow: none;

    .el-tabs__header {
      background: #f0f0f5;
    }

    .el-tabs__item {
      margin-right: 12px;
      background: #e5e5e5;
      border: none;

      &.is-active {
        background: #fff;
      }
    }

    .el-tabs__content {
      padding: 0;
    }
  }

  .tempcreate-files {
    background: #fff;
    padding: 20px;

    .tempcreate-title {
      padding: 1px 8px;
      font-size: 15px;
      font-weight: 400;
      color: #333333;
      border-left: 3px solid #3296fa;
    }

    .el-form-item {
      // margin-top: 25px;
      // padding: 0 13px;
      // color: #666666;
    }

    label {
      width: 98px;
      color: #666666;
      display: inline-block;
    }
  }

  .tempcreate-upload {
    // width: 148px;
    // height: 148px;
    // margin: 28px auto 0;
    // overflow: hidden;
    // margin-top: 27px;

    /deep/ .el-loading-mask {
      height: 140px;
      border-radius: 10px;
    }

    .uploaded-list {
      .uploaded-item {
        overflow: visible;
        width: 144px;
        height: 144px;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;

        .file-thumb {
          width: 142px;
          height: 142px;
          border-radius: 6px;
          overflow: hidden;
        }

        .file-name {
          width: 142px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          font-size: 14px;
          color: #606266;
          line-height: 1.8;
        }

        .file-actions {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          cursor: default;
          text-align: center;
          color: #fff;
          opacity: 0;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: opacity 0.3s;

          .file-preview {
            cursor: pointer;
          }

          .file-delete {
            margin-left: 15px;
            cursor: pointer;
          }

          &::after {
            display: inline-block;
            content: "";
            height: 100%;
            vertical-align: middle;
          }
        }

        .file-actions:hover {
          opacity: 1;
        }
      }
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      overflow: visible;
      width: 142px;
      height: 142px;

      .file-name {
        width: 142px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }

      .el-upload-list__item-thumbnail {
        width: 140px;
        height: 140px;
        border-radius: 6px;
        overflow: hidden;
      }
    }
  }

  .batch-create-block {
    margin-top: 20px;
  }
}

.tempcreate-params-box {
  background: #ffffff;
  padding: 20px;
}

.tempcreate-users-box {
  // padding: 0 40px;
  background: #ffffff;
  padding: 20px;

  .add-btn {
    padding: 11px 14px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
  }

  .add-user-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 23px;
  }

  // .sign-btns button.sign-button {
  //   padding: 12px 18px;
  //   background: #3296fa;
  //   border-radius: 10px;
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: #ffffff;
  //   &.line {
  //     border: 1px solid #999999;
  //     background: #fff;
  //     color: #999999;
  //     margin-left: 80px;
  //   }
  // }

  .signatory-list {
    font-size: 14px;

    .demo-table-expand {
      font-size: 0;
    }

    .demo-table-expand /deep/ label {
      min-width: 100px;
      color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
      // margin-right: 0;
      margin-bottom: 0;
      width: 100%;
      font-size: 14px;
      font-weight: normal;
    }

    /deep/ .batch-file-data-table {
      .table-list-title {
        font-size: 16px;
        font-weight: 700;
        padding: 10px 0;
      }

      .el-table__row {
        .el-table__cell {
          // padding: 0;

          // .el-descriptions-item__cell:nth-of-type(1) {
          //   border-top: none;
          // }

          // tbody:nth-last-of-type(1) .el-descriptions-item__cell {
          //   border-bottom: none;
          // }

          // .el-descriptions-item__cell {
          //   border-left: none;
          //   border-bottom: 1px solid #EBEEF5;
          //   border-right: 1px solid #EBEEF5;
          //   border-top: 1px solid #EBEEF5;
          //   text-align: center;
          // }

          // .el-descriptions-item__label {
          //   border-left: 1px solid #EBEEF5;
          //   width: 50%;
          // }

          .el-tag {
            height: unset;
            white-space: normal;
          }
        }
      }

    }

    .none-sequence {
      margin-bottom: 23px;
    }

    // margin-top: 23px;

    // width: 1120px;
    .signatory-item {
      box-sizing: border-box;
      // width: 1120px;
      // border: 3px dashed #f0f0f5;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 15px;
      // padding: 0 20px 9px 20px;
      position: relative;
      font-size: 14px;
      font-weight: 400;
      color: #333333;

      &.signatory-batch {
        padding-bottom: 18px;
      }

      &.signatory-batch .signatory-item-title {
        margin-bottom: 15px;
      }

      .signatory-item-title {
        margin: 0 0 20px 0;
        // font-size: 16px;
        color: #000000;
        // font-weight: bold;
        // line-height: 16px;
      }

      .signatory-body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 11px;

        .sub-title {
          // margin-right: 18px;
          width: 80px;
        }
      }

      .signatory-form-item {
        width: 233px;
        float: left;
        margin-right: 34px;
      }

      .auth-tag {
        width: 53px;
        padding: 2px 0;
        border: 1px solid #00d0ce;
        border-radius: 3px;
        color: #00d0ce;
        font-size: 12px;
        text-align: center;
        margin-left: -15px;

        &.icon-question {
          border: none;
          color: #e6a23c;
          font-size: 20px;
          cursor: pointer;
        }

        .auth-tip {
          display: flex;
          align-items: center;

          .auth-tip-text {
            font-size: 16px;
            white-space: nowrap;
            margin-top: -2px;
            margin-right: 3px;
          }
        }
      }
    }
  }
}

#tempcreate-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

.logo {
  margin-top: 16px;
  margin-left: 0;
  width: 111px;
  float: left;
}

.logo-text {
  margin-left: 42px;
  font-size: 24px;
  color: #ffffff;
}

.logo-s-title {
  font-size: 24px;
  color: #ffffff;
  margin-left: 24px;
}

.return-index {
  height: 71px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
  color: #ffffff;
  line-height: 71px;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.tempcreate-nav {
  width: 1200px;
  height: 54px;
  overflow: hidden;
  line-height: 42px;
  color: #333333;
  font-size: 16px;
  overflow-x: auto;
}

.tempcreate-nav a {
  display: block;
  float: left;
  width: 139px;
  height: 43px;
  overflow: hidden;
  padding: 0 18px;
  margin-right: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #e5e5e5;
  text-align: center;
}

.tempcreate-nav a:last-child {
  margin-right: 0;
}

.tempcreate-nav a.active {
  background: #ffffff;
}

.upload-tip {
  position: relative;
  top: -115px;
  font-size: 14px;
  color: #999999;
}

.upload-tip2 {
  text-align: center;
  font-size: 14px;
  color: #d75c57;
  margin-top: 20px;
}

.upload-progress {
  width: 320px;
  margin: 10px auto 0;
}

.progress-title {
  font-size: 14px;
  color: #606266;
  float: left;
}

.progress-box {
  width: 320px;
  /* float: right; */
  margin-right: -30px;
  margin-top: 4px;
}

.files-form-box {
  width: 320px;
  margin: 26px auto 0;
}

.signatory-form-item-title {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
}

.signatory-form-item-inp {
  font-size: 14px;
  color: #666666;
  line-height: 40px;
  position: relative;

  .tip {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
}

.signatory-delete {
  right: 20px;
  top: 50%;
  margin-top: -12px;
  position: absolute;
  font-size: 20px;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
  }
}

.signatory-batch,
.signatory-batch-success {
  box-sizing: border-box;
  width: 1120px;
  // height: 100px;
  border: 2px dashed rgba(240, 240, 245, 1);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 15px;
  padding: 0 20px;
  position: relative;
}

.signatory-batch-content {
  background: rgba(160, 160, 160, 0.08);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  padding: 4px;

  >div {
    padding: 8px;
  }

  .circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    color: #ffffff;
    background: #3296fa;
    border-radius: 20px;
    margin-right: 8px;
  }

  /deep/ .el-button--text {
    padding: 0;
  }

  .upload-btn {
    display: inline-block;
    margin-left: 10px;

    /deep/ .el-button {
      width: 80px;
      height: 36px;
      background: #3296fa;
      border-radius: 10px;
    }
  }
}

.signatory-batch-item {
  height: 20px;
  line-height: 20px;
  margin-bottom: 15px;
}

.step {
  float: left;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  background: #e85052;
  margin-right: 10px;
}

.step-cont {
  font-size: 14px;
  color: #666666;
}

.download-template {
  color: #d75c57;
}

.upload-template {
  height: 36px;
  /* background: #E85052; */
  color: #ffffff;
  margin-top: -5px;
  margin-left: 15px;
  width: 98px;
  float: left;
  overflow: hidden;
}

.signatory-batch-content2 {
  margin-top: 39px;
  margin-left: 40px;
  font-size: 14px;
  color: #666666;
}

.signatory-batch-text {
  /* margin-bottom: 28px; */
  font-size: 14px;
}

.show-signatory {
  color: #e25658;
  margin-right: 5px;
}

.mail-icon {
  display: block;
  width: 25px;
  position: absolute;
  right: 5px;
  top: 8px;
  z-index: 999;
  cursor: pointer;
}


.sign-btns {
  width: 750px;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
}

.sign-btns .el-button {
  width: 150px;
  height: 40px;
}

.sign-btns .el-button+.el-button {
  margin-left: 50px;

  // height: 47px;
}

// .sign-btns button:hover {
//   background: #ffffff;
//   color: #606266;
//   border-color: #dcdfe6;
// }

.h180 {
  height: 180px !important;
}

.import-head {
  display: flex;
  align-items: center;
  margin-bottom: 64px;
}

.el-button.is-circle {
  padding: 9px;
}

</style>